import React from 'react';
import Sorting from '../../views/Sorting';
import Cookies from 'js-cookie';
import '../../css/regokas.css';
import _ from 'lodash';
import Loader from '../../components/loader';
import Edit from '../../images/headericon/Edit.svg';
import Delete from '../../images/headericon/Delete.svg';
import { cancelCircle } from 'react-icons-kit/icomoon/cancelCircle';
import Success from '../../images/Success.svg';
import Error from '../../images/Error.svg';
import Delete1 from '../../images/headericon/deletedeactive.svg';
import errorText from '../../errorText';
import SearchBar from '../../views/SearchBar';
import Style from 'style-it';
import IntegrationReactSelectNew from '../../views/IntegrationReactSelectNew';
import { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
    Table,
    TableContainer,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Paper,
} from "@mui/material";
import { connect } from 'react-redux';
import * as ActionTypes from '../../actions/types';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';


class DistributorSubscription extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            subscriptionData: [],
            okasBoxDatalocation: [],
            kk: 'asdvhj',
            project_name: '',
            owner_name: '',
            address: '',
            system_integrator: '',
            status: '',
            payment: '',

            error: '',
            nameerror: '',
            namess: '',
            sortedType: '',
            searchValue: '',
            actualdata: [],
            disabledvalue: '',
            successmsgmodaldata: localStorage.getItem('dataadded'),
            showmodels: '',
            showmodels1: '',
            loader: '',
            passwordi: false,
            currentPage: 1,
            todosPerPage: 10,
            statuson: false, statustw: false, statusth: false,
            statusfo: false, statusfi: false, statussi: false,
            statusse: false, statusei: false, statusni: false,
            statuste: false,
            disableAddButton: false,
            confirmWindow: false,
            projectManagerToDelete: '',
            pagemode: ''

        };
        this.handleClickpage = this.handleClickpage.bind(this);
    }



    crosserrorfullmsg = () => {
        localStorage.removeItem('dataadded');
        this.setState({
            error: '',
        })

    }

    // confirmWindowClose = () => {
    //     this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop);

    //     this.setState({
    //         confirmWindow: false
    //     })
    // }

    // oncolseClickHandler = (event) => {
    //     this.setState({
    //         si_name: '',
    //         si_mobile: '',
    //         si_email: '',
    //         si_company: '',
    //         si_address: '',
    //         si_area: '',
    //         si_description: '',
    //         si_rating: '',
    //         si_relationstatus: '',
    //         si_gstin: '',
    //         si_type: '',
    //     })
    //     this.onclosemodel1()
    // }

    componentWillMount() {
    }

    errormsg = () => {
        setTimeout(
            function () {
                localStorage.removeItem('dataadded');
                this.setState({
                    successmsgmodaldata: '',
                    error: '',
                })
            }
                .bind(this), 3000
        );
    }

    crosssuccessfullmsg = () => {
        localStorage.removeItem('dataadded');
        this.setState({
            successmsgmodaldata: '',
        })
    }

    componentDidMount() {
        this.getallrealdata();
    }

    getallrealdata = () => {
        this.setState({
            loader: true,
        })
        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')
        }
        fetch('/we/we/subscriptionApiDistributor/', {
            method: "GET",
            headers: headers
        })
            .then(response => response.json())
            .then(subscriptionData => {
                this.setState({
                    subscriptionData,
                    actualdata: subscriptionData
                }, () => {
                    this.renderTableData();
                    // console.log(this.state.subscriptionData)
                })
                this.setState({
                    loader: false,
                })
            })


        // fetch('/we/we/locationApi/', {
        //     method: "GET",
        //     headers: headers
        // })
        //     .then(response => response.json())

        //     .then(okasBoxDatalocation => {
        //         this.setState({
        //             okasBoxDatalocation
        //         }, () => {
        //             this.renderTableDatalocation();
        //             this.renderLocation();
        //             console.log(this.state.okasBoxDatalocation);
        //         })
        //     })
    }



    renderTableDatalocation = (type) => {
        if (type === 'location') {
            var typee = 0;
            let xx = this.state.okasBoxDatalocation.map((e, index) => {
                // console.log(e)
                typee = typee + 1;
                return (
                    <option key={index} value={e.ID}>{e.location}</option>
                )
            });
            return xx;
        }
    }

    renderLocation = () => {
        let LocationData = [];
        if (Array.isArray(this.state.okasBoxDatalocation)) {
            this.state.okasBoxDatalocation.forEach((e) => {
                LocationData.push({
                    label: e.location,
                    value: e.ID.toString()
                });
            });
            this.setState({
                LocationData: LocationData
            });
        } else {
            return null;
        }
    }




    handleClickpage(event) {
        this.setState({
            currentPage: Number(event.target.id)
        });
        this.renderTableData('type1');
        this.renderTableData('pagination');
    }




    renderTableData = (type) => {
        if (this.state.subscriptionData.detail == 'Invalid token.') {
            localStorage.removeItem('auth');
            localStorage.removeItem('username');
            this.props.history.push('/login')
        }

        let indexOfLastTodo = this.state.currentPage * this.state.todosPerPage;
        let indexOfFirstTodo = indexOfLastTodo - this.state.todosPerPage;
        let currentTodos = this.state.subscriptionData.slice(indexOfFirstTodo, indexOfLastTodo);

        if (type === 'pagination') {
            let pageNumbers = [];
            for (let i = 1; i <= Math.ceil(this.state.subscriptionData.length / this.state.todosPerPage); i++) {
                pageNumbers.push(i);
            }
            let renderPageNumbers = pageNumbers.map((number, i) => {
                if ((this.state.currentPage - 3 < i + 1) && ((this.state.currentPage + 3 > i + 1 || 6 > i + 1))) {
                    return (
                        <li className={this.state.currentPage == number ? "active" : null}><a id={number} onClick={this.handleClickpage}>{number}</a></li>
                    );
                }
            });
            return renderPageNumbers;
        }

        if (type === 'type1') {
            var typee = 0;
            let xx = currentTodos.map((e, index) => {
                typee = typee + 1;
                // let siId = e.si_id;
                // let pmid = e.id;
                // let pmname = e.first_name;
                return (
                    <tr key={index} >
                        <td className={this.props.windowWidth > 760 ? "qwerty" : ""}>{(this.state.currentPage * this.state.todosPerPage) - this.state.todosPerPage + index + 1}</td>
                        {/* <td>{e.id}</td> */}
                        <td>{e.project_name}</td>
                        <td >{e.owner_name}</td>
                        <td>{e.address}</td>
                        <td>{e.system_integrator}</td>
                        {/* <td>{e.status}</td> */}
                        <td>{e.status === "active" ? <span style={{ color: "green" }}>ACTIVE</span>
                            : e.status === "about_to_expire" ? <span style={{ color: "#FFD800" }}>ABOUT TO EXPIRE</span>
                                : e.status === "expired" ? <span style={{ color: "red" }}>EXPIRED</span>
                                    : <span style={{ color: "grey" }}>NA</span>
                        }
                        </td>
                        <td>{e.payment === "complete" ? <span style={{ color: "green" }}>COMPLETED</span>
                            : e.payment === "due" ? <span style={{ color: "red" }}>DUE</span>
                                : <span style={{ color: "grey" }}>NA</span>
                        }
                        </td>

                    </tr>
                )
            });
            return xx;
        }
    }



    // onopenmodel = (event) => {
    //     this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop);

    //     this.setState({
    //         showmodels: 'true',
    //         pagemode: ''
    //     })
    //     this.props.searchBarActivate(false)
    // }

    // onclosemodel = (event) => {
    //     this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop);

    //     this.setState({
    //         showmodels: '',
    //         error: '',
    //         si_name: '',
    //         si_mobile: '',
    //         si_email: '',
    //         si_company: '',
    //         si_address: '',
    //         si_area: '',
    //         si_description: '',
    //         si_rating: '',
    //         si_relationstatus: '',
    //         si_gstin: '',
    //         si_type: '',
    //         nameerror: '',
    //         phoneerror: '',
    //         emailerror: '',
    //         areaerror: '',
    //         addresserror: '',
    //         descriptionerror: '',
    //         ratingerror: '',
    //         companyerror: '',
    //         relationstatuserror: '',
    //         gstinerror: '',
    //         typeerror: '',
    //         disableAddButton: false
    //     })
    // }


    // onopenmodel1 = (event) => {
    //     this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop);        
    //     this.setState({
    //         showmodels1: 'true',
    //     })
    // }

    // onclosemodel1 = (event) => {
    //     this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop);

    //     this.setState({
    //         showmodels1: '',
    //     })
    // }

    // setpasswordi = (buttonaction) => {
    //     this.setState({
    //         passwordi: !this.state.passwordi,
    //     })
    // }


    restoreData = (data) => {
        this.setState({
            subscriptionData: data,
        })
    }


    sortingFunc = (type, searchValue) => {


        if (type !== "search") {
            this.props.searchBarActivate(false)
        }

        if (type == "project_name") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false,
                statuson: !this.state.statuson,
            })
        }
        if (type == "owner_name") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false,
                statuson: !this.state.statuson,
            })
        }
        if (type == "address") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false,
                statustw: !this.state.statustw,
            })
        }
        if (type == "system_integrator") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false,
                statusth: !this.state.statusth,
            })
        }
        if (type == "status") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false,
                statusth: !this.state.statusth,
            })
        }
        if (type == "payment") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false,
                statusth: !this.state.statusth,
            })
        }


        if (this.state.sortedType !== type && type !== 'search') {
            this.setState({
                sortedType: type
            })
            Sorting(this.restoreData, type, this.state.subscriptionData);
        } else if (type === 'search') {
            type = 'search';
            Sorting(this.restoreData, type, this.state.actualdata, searchValue);
        } else {
            type = 'reverse';
            Sorting(this.restoreData, type, this.state.subscriptionData);
        }
    }




    // onSearchClick = () => {
    //     this.props.searchBarActivate(!this.props.redux.globalVar.searchBarShow)
    // }

    onSelectChange = (operationMode, valueSelect) => {
        if (valueSelect.label !== undefined) {
            this.setState({
                [operationMode]: valueSelect.value,
                error: false,
                locationerror: false,
            })

        }
    }


    render() {
        return Style.it(`
        @media only screen and (max-width: 760px){
      td:nth-of-type(1):before { content: "S.NO"; }
      td:nth-of-type(2):before { content: "Project Name"; }
      td:nth-of-type(3):before { content: "Owner Name"; }
      td:nth-of-type(4):before { content: "Address"; }
      td:nth-of-type(5):before { content: "System Integrator"; }
      td:nth-of-type(6):before { content: "Status"; }
      td:nth-of-type(7):before { content: "Payment"; }
    }`, <div>
            <ToastContainer />
            <div className="selfcontainer"
                style={{
                    position: !this.props.redux.globalVar.backgroundScrollStop && this.props.windowWidth < 760 ? "fixed" : "absolute",
                    overflow: !this.props.redux.globalVar.backgroundScrollStop && this.props.windowWidth < 760 ? "hidden" : ""
                }}

            >
                <ToastContainer />
                {this.state.loader ? <Loader /> : null}

                {this.props.redux.globalVar.searchBarShow ?
                    <div className='row searchinput'>
                        <SearchBar
                            autoFocus
                            value={this.state.searchValue}
                            onChange={(e) => {
                                this.setState({
                                    searchValue: e
                                }, () => {
                                    this.sortingFunc('search', this.state.searchValue)
                                })
                            }
                            }
                            onRequestSearch={() => this.sortingFunc('search', this.state.searchValue)}
                            resetSearch={(e) => {
                                this.setState({
                                    searchValue: e
                                }, () => {
                                    this.sortingFunc('search', '')
                                })
                            }}
                        />
                    </div>
                    : ''}
                <div className="row" onContextMenu={(e) => { e.preventDefault(); }}>
                    <h3>Subscriptions</h3>
                    <h6 className="mb-3 mt-0">Find the comprehensive view and details of all subscriptions from the users.</h6>
                    {/* <div className={this.state.successmsgmodaldata ? 'successmsgbox' : 'successmsgbox successmsgboxnone'}  >
                        <div className="inblksuccfull"><img src={Success} /></div>
                        <div className="inblksucc1">
                            SUCCESS !
                            <a className="successmsgcross"><Icon icon={cross} size={20} onClick={(e) => { this.crosserrorfullmsg(this) }} /></a>
                        </div>
                    </div> */}

                    <div className="tests">
                        <TableContainer component={Paper} className={this.props.windowWidth > 760 ? "table custom-striped-table-dashboard dashboardtablemain" : ""}>
                            <Table className={"tablecontent"}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{color:'white', fontSize:'11px'}}>S.No</TableCell>
                                        <TableCell sx={{color:'white', fontSize:'11px'}}>
                                            Project Name
                                            {this.props.statuson ? (
                                                <IoIosArrowUp style={{color:'white'}} size={16} className="pull-right" onClick={() => this.sortingFunc("project_name", "")} />
                                            ) : (
                                                <IoIosArrowDown style={{color:'white'}} size={16} className="pull-right" onClick={() => this.sortingFunc("project_name", "")} />
                                            )}
                                        </TableCell>
                                        <TableCell sx={{color:'white', fontSize:'11px'}}>
                                            Owner Name
                                            {this.props.statustw ? (
                                                <IoIosArrowUp style={{color:'white'}} size={16} className="pull-right" onClick={() => this.sortingFunc("owner_name", "")} />
                                            ) : (
                                                <IoIosArrowDown style={{color:'white'}} size={16} className="pull-right" onClick={() => this.sortingFunc("owner_name", "")} />
                                            )}
                                        </TableCell>
                                        <TableCell sx={{color:'white', fontSize:'11px'}}>
                                            Address
                                            {this.props.statusth ? (
                                                <IoIosArrowUp style={{color:'white'}} size={16} className="pull-right" onClick={() => this.sortingFunc("address", "")} />
                                            ) : (
                                                <IoIosArrowDown style={{color:'white'}} size={16} className="pull-right" onClick={() => this.sortingFunc("address", "")} />
                                            )}
                                        </TableCell>
                                        <TableCell sx={{color:'white', fontSize:'11px'}}>
                                            System Integrator
                                            {this.props.statusfo ? (
                                                <IoIosArrowUp style={{color:'white'}} size={16} className="pull-right" onClick={() => this.sortingFunc("system_integrator", "")} />
                                            ) : (
                                                <IoIosArrowDown style={{color:'white'}} size={16} className="pull-right" onClick={() => this.sortingFunc("system_integrator", "")} />
                                            )}
                                        </TableCell>
                                        <TableCell sx={{color:'white', fontSize:'11px'}}>
                                            Status
                                            {this.props.statusfi ? (
                                                <IoIosArrowUp style={{color:'white'}} size={16} className="pull-right" onClick={() => this.sortingFunc("status", "")} />
                                            ) : (
                                                <IoIosArrowDown style={{color:'white'}} size={16} className="pull-right" onClick={() => this.sortingFunc("status", "")} />
                                            )}
                                        </TableCell>
                                        <TableCell sx={{color:'white', fontSize:'11px'}}>
                                            Payment
                                            {this.props.statusfi ? (
                                                <IoIosArrowUp style={{color:'white'}} size={16} className="pull-right" onClick={() => this.sortingFunc("payment", "")} />
                                            ) : (
                                                <IoIosArrowDown style={{color:'white'}} size={16} className="pull-right" onClick={() => this.sortingFunc("payment", "")} />
                                            )}
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.renderTableData("type1")}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <div className="pull-right">
                            {this.state.todosPerPage < this.state.subscriptionData.length ?
                                <ul className="pagination pull-right paginat">

                                    <li>
                                        <span className="">Showing {(this.state.currentPage * this.state.todosPerPage) - this.state.todosPerPage + 1} -{this.state.currentPage * this.state.todosPerPage - this.state.subscriptionData.length < 0 ? this.state.currentPage * this.state.todosPerPage : this.state.subscriptionData.length}  of {this.state.subscriptionData.length} enteries</span>
                                    </li>

                                    <li>
                                        <a
                                            onClick={this.state.currentPage == -1 + this.state.currentPage * this.state.todosPerPage ? null :
                                                this.handleClickpage.bind(this, this.state.currentPage - 1)
                                            }
                                            aria-label="Previous">
                                            <span aria-hidden="true">&laquo;</span>
                                            <span className="sr-only">Previous</span>
                                        </a>
                                    </li>

                                    {this.renderTableData('pagination')}
                                    <li className="">
                                        <a className=""
                                            onClick={this.state.currentPage * this.state.todosPerPage == this.state.subscriptionData.length ? null :
                                                this.handleClickpage.bind(this, this.state.currentPage + 1)
                                            }

                                            aria-label="Next">
                                            <span aria-hidden="true">&raquo;</span>
                                            <span className="sr-only">Next</span>
                                        </a>
                                    </li>
                                </ul>
                                : null}
                        </div>

                    </div> </div>

            </div>
        </div>
        );
    }

}

const mapStateToProps = state => {
    return {
        redux: state,
    };
};


const mapDispatchToProps = dispatch => {
    return {
        searchBarActivate: (data) => dispatch({ type: ActionTypes.SEARCHBAR, data: data }),
        searchBarStyleActivate: (data) => dispatch({ type: ActionTypes.SEARCHBARSTYLE, data: data }),
        backgroundScrollStop: (data) => dispatch({ type: ActionTypes.SCROLLSTOP, data: data }),

    };
};


// export default windowSize(connect(mapStateToProps, mapDispatchToProps)(DistributorSubscription)); 
export default connect(mapStateToProps, mapDispatchToProps)(DistributorSubscription); 